import { gql } from '@apollo/client';

export const COUNTRY_QUERY = gql`
    query Countries {
    countries {
        id
        name
        countryCode
    }
    }
`;

export const COUNTRY_LANGUAGE_QUERY = gql`
    query CountriesLanguages {
    countries {
        id
        name
        countryCode
    }

    languages {
        id
        name
    }
    }

`;
